import React from "react";

const QuickButton = ({ name, img, backgroundImage, onSelect }) => {
  return (
    <span 
      title={name} 
      className=" col-span-1 px-[3px] py-[3px]"
      onClick={()=>{onSelect();}}
    >
      <div
        className="relative w-full active:scale-95 cursor-pointer  bg-bg_SkeletonBgLoaderColor transition-all ease-in-out duration-150 shadow-quickAccessBtnBoxShadows min-h-9 bg-cover bg-center bg-no-repeat rounded-[4px] overflow-hidden undefined"
        style={{backgroundImage: backgroundImage}}
      >
        <div className="flex justify-center w-full h-full min-h-9 relative z-10 items-center min-w-[175px] sm:min-w-[240px] md:min-w-[280px] pl-[5px] pt-[2px] pb-[2px] pr-1  opacity-100">
          <img
            src={img}
            width="16"
            height="16"
            className="  w-4 h-4 sm:w-5 sm:h-5  ml-1 autoAnimate  "
            alt={`${name}-image`}
            loading="lazy"
            title={name}
          />
          <span className=" ml-1 autoAnimate text-text_Quaternary text-xs capitalize pr-[2px] md:text-sm text-nowrap w-full truncate font-lato-bold  font-semibold md:font-semibold">
            {name}
          </span>
        </div>
        <div className="absolute top-0 left-0 w-full h-full  min-h-9 rounded-[4px] "></div>
      </div>
    </span>
  );
};

export default QuickButton;
